<nav
  class="bottom-nav"
  [ngClass]="{ 'bottom-nav--hidden': !isVisible() }"
  [attr.aria-label]="'ARIA.MAIN_NAVIGATION' | translate"
>
  @for (item of items; track item.route) {
  <button
    type="button"
    class="bottom-nav__item"
    [ngClass]="{ 'bottom-nav__item--active': isItemActive(item) }"
    (click)="onItemClick(item)"
    [attr.aria-current]="isItemActive(item) ? 'page' : null"
  >
    <fa-icon
      class="bottom-nav__icon"
      [icon]="item.iconClass | faIconName"
    ></fa-icon>
    <span class="bottom-nav__label">{{ item.keyTitle | translate }}</span>
  </button>
  }

  <div class="bottom-nav__item">
    <app-chat-button
      [unreadCount]="chatUnreadCount"
      [showLabel]="true"
      (chatClicked)="onChatClick()"
    ></app-chat-button>
  </div>

  @if (showMenuButton) {
  <button
    type="button"
    class="bottom-nav__item"
    (click)="onMenuClick()"
    [attr.aria-label]="'ARIA.OPEN_MENU' | translate"
  >
    <fa-icon class="bottom-nav__icon" [icon]="['fass', 'bars']"></fa-icon>
    <span class="bottom-nav__label">{{ 'MORE' | translate }}</span>
  </button>
  }
</nav>
